import { Column, Entity, JoinColumn, ManyToOne, PrimaryColumn, PrimaryGeneratedColumn } from 'typeorm';
import { Entente } from '.';

@Entity('note_entente')
export default class NoteEntente {
    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: false })
    name: string; // contenu de la note

    @PrimaryColumn()
    fk_id_entente: number;

    @ManyToOne(() => Entente)
    @JoinColumn({ name: 'fk_id_entente', referencedColumnName: 'id' })
    entente: Entente;

    @Column({ nullable: false })
    pour_quoi: string; // csv qui peut contenir "client,activite1,activite2,[etc.]" activite1 et activite2, 1 et 2 sont les id des activités.

    @Column({ nullable: false })
    origine_note: string;
}
